import PropTypes from 'prop-types'

export default {
    id: PropTypes.number,
    name: PropTypes.string,
    slug: PropTypes.string,
    status: PropTypes.number,
    synced: PropTypes.bool,
}
